module.exports = {"130637100":"博野镇","130637101":"小店镇","130637102":"程委镇","130637103":"东墟镇","130637104":"北杨镇","130637105":"城东镇","130637106":"南小王镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130637.json
// module id = 257
// module chunks = 0